import React from 'react';

import {labels} from '../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

export const config = () => ({
	id: `addedColumn`,
	propName: 'accountId',
	width: 'var(--px-90)',
	customCell: (item) => {
		const text = labels.added;
		return (
			<>
				{item?.isSelected && !item.isLoading && (
					<OutputText body2 light ellipsis title={text}>
						{text}
					</OutputText>
				)}
			</>
		);
	}
});
